import React, { useState } from "react";

import styles from "./PaigeReview.module.scss";

var FindingCard = function (props) {
  var finding = props.finding;
  var analysisType = props.analysisType;
  var onFindingClick = props.onFindingClick;

  var _expanded = useState(false);
  var isExpanded = _expanded[0];
  var setIsExpanded = _expanded[1];

  var getSeverityClass = function () {
    switch (finding.severity) {
      case "critical":
        return styles.severityCritical;
      case "warning":
        return styles.severityWarning;
      case "info":
        return styles.severityInfo;
      default:
        return "";
    }
  };

  var handleHeaderClick = function () {
    setIsExpanded(!isExpanded);
  };

  var handleNavigateClick = function (e) {
    e.stopPropagation();
    if (onFindingClick && finding.page_number != null) {
      onFindingClick(finding);
    }
  };

  var codeSectionLinkMap = {
    2.6: "/references/26/pid/961d55e1-733e-c315-e18c-17ec83e1ae20",
    2.4: "/references/26/pid/9c8e2344-8305-a67c-e276-94b17897e75a",
    4.2: "/references/26/pid/36e85231-9ae0-af5a-a4e0-e05fe239642c",
    4.3: "/references/26/pid/18b57c5a-bf6f-ac95-e5ac-4602868be28c",
  };

  var renderCodeSection = function () {
    // For Illumina, show the rule_id directly (e.g., "ruo-footer-per-page")
    if (analysisType === "illumina") {
      if (!finding.rule_id) return null;
      return <span className={styles.codeSection}>{finding.rule_id}</span>;
    }

    // For Menopur, show "Rule <rule_id>" (e.g., "Rule 1.1")
    if (analysisType === "menopur") {
      if (!finding.rule_id) return null;
      return <span className={styles.codeSection}>Rule {finding.rule_id}</span>;
    }

    if (!finding.code_section) return null;

    // For PAAB, prefix with "PAAB Code"
    // For FDA, the code_section already contains the CFR citation (e.g., "21 CFR 202.1(e)(6)(i)")
    var label =
      analysisType === "fda"
        ? finding.code_section
        : "Regulatory Code " + finding.code_section;

    var link = codeSectionLinkMap[finding.code_section];

    if (link) {
      return (
        <a
          href={link}
          className={styles.codeSection + " " + styles.codeSectionLink}
          onClick={function (e) {
            e.stopPropagation();
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {label}
        </a>
      );
    }

    return <span className={styles.codeSection}>{label}</span>;
  };

  // Menopur findings don't carry violation_direction (missing/spurious doesn't
  // apply to visual imagery). Show the severity word instead so the badge text
  // reads naturally (e.g., "Critical", "Warning").
  var renderBadgeLabel = function () {
    if (analysisType === "menopur") {
      if (finding.severity === "critical") return "Critical";
      if (finding.severity === "warning") return "Warning";
      if (finding.severity === "info") return "Info";
      return "Issue";
    }
    if (
      finding.metadata &&
      finding.metadata.violation_direction === "spurious"
    ) {
      return "Spurious";
    }
    return "Critical";
  };

  var cardClass = isExpanded
    ? styles.findingCard + " " + styles.findingCardExpanded
    : styles.findingCard;

  return (
    <div className={cardClass}>
      <div className={styles.findingHeader} onClick={handleHeaderClick}>
        <span className={styles.severityBadge + " " + getSeverityClass()}>
          {renderBadgeLabel()}
        </span>
        <span className={styles.findingCategory}>{finding.category}</span>
        {renderCodeSection()}
        {finding.page_number != null && (
          <span className={styles.headerPageNote}>p.{finding.page_number}</span>
        )}
        <span className={styles.expandToggle}>
          {isExpanded ? "\u25B2" : "\u25BC"}
        </span>
      </div>

      {isExpanded && (
        <div className={styles.findingBody}>
          <div className={styles.findingDescription}>{finding.description}</div>

          {finding.extracted_text && (
            <div className={styles.extractedText}>
              <span className={styles.quoteIcon}>"</span>
              {finding.extracted_text}
              <span className={styles.quoteIcon}>"</span>
            </div>
          )}

          {finding.recommendation && (
            <div className={styles.recommendation}>
              <div className={styles.recommendationLabel}>Recommendation</div>
              <div className={styles.recommendationText}>
                {finding.recommendation}
              </div>
            </div>
          )}

          {finding.page_number != null && (
            <div className={styles.findingFooter}>
              <span
                className={styles.pageNoteLink}
                onClick={handleNavigateClick}
              >
                Go to page {finding.page_number}
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FindingCard;
